module.exports = __webpack_public_path__ + "img/iPad-Portrait@2x.654eea21.png";